module.exports = __webpack_public_path__ + "static/media/vnda6.2c8c451f.png";